<script>
    import API from '../../States/API';
    import Router from '../../States/Router';
    import Agent from '../../States/Agent'
    import Session from '../../States/Session'
    import Notification from '../../States/Notification'
    import Conference from '../../States/Conference';
    import Twilio from '../../States/Twilio';
    import Helper from '../../Models/Helper';

    let searchValue;
    let list = [];

    Twilio.subscribe(state => {
        if(state.error) {
            const errorModal = new bootstrap.Modal(document.getElementById('twilio-error-modal'))
            errorModal.show();
        }
    });

    function goToPerson(id, type, phone) {
        if(type == 'contact')
            Router.component('contact', {id, phone})
        else if(type == 'agent')
            Router.component('agent', {id})

    }

    function logout() {
        Agent.logout();
        Router.component('login');
    }

    function testNotification() {
        Agent.testNotification();
    }

    async function search(event) {
        window.$('.app-search .dropdown-lg').addClass('d-block');
        const search = encodeURIComponent(searchValue);
        const response = await API.request('get', `search?search=${search}`, false, false)
        if(response.success)
            list = response.list;
    }

    function pickup(contactId, conferenceName) {
        Conference.answer(conferenceName, contactId);
        Router.component('conference', {contact: true, pickup: true, contactId, conferenceName})
    }

    function pickupAgent(agentId, conferenceName) {
        Router.component('conference', {agent: true, pickup: true, agentId, conferenceName})
        Notification.removeIncoming({conferenceName})
    }

    function answer(contactId, conferenceName) {
        Router.component('conference', {contact: true, answer: true, contactId, conferenceName})
        Notification.removeIncoming({conferenceName})
    }

    function initialize() {
        Twilio.setError(false);
        Twilio.init(true);
    }

    function reload() {
        Twilio.setError(false);
        window.location.href = '/';
    }
</script>
<style>
    .topnav-logo {
        font-family: "Grand Hotel";
        color: white;
        font-size: 2.5em;
        cursor: pointer;
    }

    .notify-item {
        cursor: pointer;
    }

    .app-search {
        display: grid;
        grid-template-columns: 50%;
        width: 100%;
        justify-content: center;
    }

    .app-search form {
        max-width: unset;
    }

    .app-search .round-name, #search-dropdown-mobile .round-name {
        margin-right: 1em;
    }

    .toast {
        margin-right: 2em;
        margin-top: 2em;
    }

    .notification-list h5 {
        text-transform: capitalize;
    }

    .navbar-container {
        display: grid;
        grid-template-columns: 10% 75% 15%;
    }

    .topbar-menu {
        display: flex;
        justify-content: right;
    }

    #toast-container {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1004;
    }

    @media (max-width: 992px) {
        .navbar-container {
            grid-template-columns: 25% 12% 63%;
        }
    }
</style>

<div id="toast-container">
    {#each $Notification.incoming as item}
        {#if item.type == 'incoming'}
            <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                    <strong class="me-auto">Speakly</strong>
                    <button type="button" class="ms-2 mb-1 btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div class="toast-body">
                    <div><b>{item.contactName}</b> is calling</div>
                    <div class="mt-2 pt-2 border-top">
                        <button type="button" class="btn btn-success btn-sm" on:click={() => {pickup(item?.contactId, item?.conferenceName)}}>Pickup</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="toast">Ignore</button>
                    </div>
                </div>
            </div>
        {/if}

        {#if item.type == 'incoming-agent'}
            <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                    <strong class="me-auto">Speakly</strong>
                    <button type="button" class="ms-2 mb-1 btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div class="toast-body">
                    <div><b>{item.agentName}</b> is calling</div>
                    <div class="mt-2 pt-2 border-top">
                        <button type="button" class="btn btn-success btn-sm" on:click={() => {pickupAgent(item?.agentId, item?.conferenceName)}}>Pickup</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="toast">Ignore</button>
                    </div>
                </div>
            </div>
        {/if}

        {#if item.type == 'incoming-forward'}
            <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                    <strong class="me-auto">Speakly</strong>
                </div>
                <div class="toast-body">
                    <div><b>{item.agentName}</b> is forwarding <b>{item.contactName}</b> to you</div>
                    <div class="mt-2 pt-2 border-top">
                        <button type="button" class="btn btn-success btn-sm" on:click={() => {answer(item?.contactId, item?.conferenceName)}}>Pickup</button>
                    </div>
                </div>
            </div>
        {/if}
    {/each}
</div>

<div class="modal fade" id="twilio-error-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Twilio Error!</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"></button>
            </div>
            <div class="modal-body">
                There has been a error with the Twilio connection.
            </div>
            <div class="modal-footer">
                <a href="javascript:void(0);" class="btn btn-light" data-bs-dismiss="modal" on:click={() => {initialize()}}>Close</a>
                <button type="button" class="btn btn-primary" on:click={() => {reload()}}>Refresh</button>
            </div>
        </div>
    </div>
</div>

<div id="preloader">
    <div id="status">
        <div class="bouncing-loader"><div ></div><div ></div><div ></div></div>
    </div>
</div>


<div class="navbar-custom topnav-navbar topnav-navbar-dark">
    <div class="container-fluid navbar-container">
        <div on:click="{event => Router.component('dashboard')}" class="topnav-logo"> Speakly </div>
        <div class="button-menu-mobile disable-btn">
            <div class="lines">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="app-search d-xl-grid d-none dropdown">
            <div>
                <form>
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Search..." id="top-search" bind:value="{searchValue}" on:input={Helper.debounce(search, 500)}>
                        <span class="mdi mdi-magnify search-icon"></span>
                    </div>
                </form>
                <div class="dropdown-menu dropdown-menu-animated dropdown-lg" id="search-dropdown">
                    <div class="dropdown-header noti-title">
                        <h5 class="text-overflow mb-2">Found <span class="text-danger">{list.length}</span> results</h5>
                    </div>
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow mb-2 text-uppercase">Contacts</h6>
                    </div>
                    <div class="notification-list">
                        {#each list as item}
                            {#if item.type == 'contact'}
                                <div class="dropdown-item notify-item" on:click="{event => goToPerson(item.id, item.type, item?.phone)}">
                                    <div class="d-flex">
                                        <div class="round-name">{item.initials}</div>
                                        <div class="w-80">
                                            <h5 class="m-0 font-14">{item.name}</h5>
                                            <span class="font-12 mb-0">{item.company ? item.company : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        {/each}
                    </div>
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow mb-2 text-uppercase">Agents</h6>
                    </div>
                    <div class="notification-list">
                        {#each list as item}
                            {#if item.type == 'agent'}
                                <div class="dropdown-item notify-item" on:click="{event => goToPerson(item.id, item.type, item?.phone)}">
                                    <div class="d-flex">
                                        <div class="round-name">{item.initials}</div>
                                        <div class="w-80">
                                            <h5 class="m-0 font-14">{item.name}</h5>
                                            <span class="font-12 mb-0">{item.company ? item.company : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <ul class="list-unstyled topbar-menu float-end mb-0">
            <li class="dropdown notification-list d-xl-none">
                <div class="nav-link dropdown-toggle arrow-none pointer" data-bs-toggle="dropdown"  role="button" aria-haspopup="false" aria-expanded="false">
                    <i class="dripicons-search noti-icon"></i>
                </div>
                <div class="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
                    <form class="p-3">
                        <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username" bind:value="{searchValue}" on:input={Helper.debounce(search, 500)} />
                    </form>
                    <div class="dropdown-menu dropdown-menu-animated dropdown-lg d-block d-md-none" id="search-dropdown-mobile">
                        <div class="dropdown-header noti-title">
                            <h5 class="text-overflow mb-2">Found <span class="text-danger">{list.length}</span> results</h5>
                        </div>
                        <div class="dropdown-header noti-title">
                            <h6 class="text-overflow mb-2 text-uppercase">Users</h6>
                        </div>
                        <div class="notification-list">
                            {#each list as item}
                                <div class="dropdown-item notify-item" on:click="{event => goToPerson(item.id, item.type, item?.phone)}">
                                    <div class="d-flex">
                                        <div class="round-name">{item.initials}</div>
                                        <div class="w-80">
                                            <h5 class="m-0 font-14">{item.name} - {item.type}</h5>
                                            <span class="font-12 mb-0">{item.company ? item.company : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                </div>
            </li>
            <li class="dropdown notification-list">
                <div class="nav-link dropdown-toggle nav-user arrow-none me-0 pointer" data-bs-toggle="dropdown" id="topbar-userdrop" role="button" aria-haspopup="true"
                    aria-expanded="false">
                    <span class="account-user-avatar round-name">
                        {$Session.user.initials}
                    </span>
                    <span>
                        <span class="account-user-name">{$Session.user.name}</span>
                        <span class="account-position">Agent</span>
                    </span>
                </div>
                <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown" aria-labelledby="topbar-userdrop">
                    <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">Welcome!</h6>
                    </div>
                    <!-- <div class="dropdown-item notify-item">
                        <i class="mdi mdi-account-circle me-1"></i>
                        <span>My Account</span>
                    </div>
                    <div class="dropdown-item notify-item">
                        <i class="mdi mdi-account-edit me-1"></i>
                        <span>Settings</span>
                    </div> -->
                    <div class="dropdown-item notify-item" on:click="{testNotification}">
                        <i class="mdi mdi-bell me-1"></i>
                        <span>Test notification (5 sec)</span>
                    </div>
                    <div class="dropdown-item notify-item" on:click="{logout}">
                        <i class="mdi mdi-logout me-1"></i>
                        <span>Logout</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>